import { makeStyles } from 'tss-react/mui'
import CloseIcon from '@mui/icons-material/Close'
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import genericStyles from 'styles/material-styles/genericStyles.js'
import _colors from '../../../styles/global/_colors'
import { InfoProps } from '../../../ts/interfaces/infoProps.interface'
import { ThemeType } from '../../../ts/types/theme.types'

const useStyles = makeStyles()((theme: ThemeType) => ({
  warning: {
    ...genericStyles.alertContainer,
    background: `linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), ${_colors.blue}`,
    color: `${_colors.blueDark}`,
    border: '2px solid rgba(0, 150, 214, 0.5)',
  },
  icon: {
    color: `${_colors.blueDark}`,
  },
  close: {
    marginLeft: '15px',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  content: {
    padding: '0 8px 0 8px',
  },
  okButton: {
    textDecoration: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}))

const Info = ({ onClose, description, onOk }: InfoProps) => {
  const { classes } = useStyles()
  return (
    <div className={classes.warning}>
      <ReportProblemOutlinedIcon className={classes.icon} />
      <div className={classes.content}>{description}</div>
      {onOk && (
        <Button
          onClick={onOk}
          color="inherit"
          size="small"
          data-testid="info-ok-button"
          className={classes.okButton}
        >
          OK
        </Button>
      )}
      <IconButton
        key="close"
        aria-label="Close"
        color="inherit"
        className={classes.close}
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </div>
  )
}

export default Info
